export default __webpack_public_path__ + "static/artboard-anim-3-95bc64607a34a552bc707ebde6450d39.webm";